/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import moment from "moment-timezone";

/*Returns local time .Needs UTC time and TimeZone as input*/
export const getLocalTime = ({
  utcTime,
  timezone,
}: {
  utcTime: string;
  timezone: string;
}) => {
  const utcDate = new Date(utcTime);
  let offsetValStr = "";
  let offsetValList = [];
  let offsetHoursVal = 0;
  let offsetMinutesVal = 0;
  let matchedUTCoffsetStrList =
    timezone && timezone.match(/UTC[+-][0-9]*[:][0-9]*/);
  let matchedHoursOnlyStrList = timezone && timezone.match(/UTC[+-]\d*/);

  if (matchedUTCoffsetStrList) {
    /**Incase of both hours and minuter in the format like H:MM or HH:MM */
    offsetValStr = matchedUTCoffsetStrList[0].replace(/UTC/, "");
    // CID 3401030
    if (
      offsetValStr !== null &&
      offsetValStr !== undefined &&
      offsetValStr.length > 1
    ) {
      offsetValList = offsetValStr.split(":").map((ele) => Number(ele));

      offsetHoursVal = offsetValList[0];
      offsetMinutesVal = offsetValList[1];
    }
  } else if (matchedHoursOnlyStrList) {
    /**Incase of only Hours in the format like UTC-H or UTC+HH */
    offsetValStr = matchedHoursOnlyStrList[0].replace(/UTC/, "");
    if (offsetValStr.length > 1) {
      offsetHoursVal = Number(offsetValStr);
    }
  } else {
    /** */
  }

  utcDate.setUTCHours(utcDate.getUTCHours() + offsetHoursVal);
  utcDate.setUTCMinutes(utcDate.getUTCMinutes() + offsetMinutesVal);

  const utcDateTime = utcTime && timezone && moment.utc(utcDate.toISOString());
  // return utcDateTime && utcDateTime.format("h:mm A, MMM D YYYY");
  return utcDateTime && utcDateTime.format("YYYY/MM/DD HH:mm:ss");
};
